import React from "react";
import { BlockProps } from "../../models/Global/types";
import { IUnit } from "../../models/Unit/types";
import Block from "../Block";
import PrescriptionInfo from "./PrescriptionInfo";
import {IPrescription} from "../../models/Prescription/types";

function PrescriptionBlock({ data }: BlockProps<IPrescription>) {
    const [open, setOpen] = React.useState<boolean>(false);

    function handleOpenModal() {
        setOpen(true);
    }

    function handleClose() {
        setOpen(false);
    }
    return <>
        <PrescriptionInfo
            open={open}
            // loading={getDevice.isLoading}
            data={data}
            handleClose={handleClose}
        />
        <Block data={data} label={'bed_integration'} handleOpenModal={setOpen}></Block>

    </>
}

export default PrescriptionBlock;